<header class="modal-header" *ngIf="title">
  <h1 class="h3 modal-title">{{ title }}</h1>
  <button
    ndt-icon-button
    type="button"
    class="text-secondary-500 hover:opacity-75"
    aria-label="Zamknij"
    i18n-aria-label
    (click)="decline()"
  >
    <app-icon name="close" size="lg"></app-icon>
  </button>
</header>

<div *ngIf="message" class="modal-body">{{ message }}</div>

<footer class="modal-footer">
  <button ndt-tertiary-button type="button" (click)="decline()">
    {{ declineBtnText }}
  </button>
  <button ndt-primary-button type="button" [disabled]="disabledButton" (click)="confirm()">
    {{ confirmationBtnText }}
  </button>
</footer>
